export default function initLottie() {
    const ww = jQuery(window).width()
    const path = ww >= 1200 ? "Enero_HomepageHero_Lottie_DESKTOP.json" : "Enero_HomepageLottie_MOBILE.json"
    const animation = lottie.loadAnimation({
        container:document.getElementById('bannerAnimations'),
        renderer:'svg',
        loop:true,
        autoplay:true,
        path:theme_url + '/assets/lottie/' + path
    })
}